// extracted by mini-css-extract-plugin
module.exports = {"TagsList":"TagsList_TagsList__3dqid"};